enum ServerDocTypes {
  // Documents for AR and AP (affects GL)
  INTERNAL_PURCHASE_INVOICE = "INTERNAL_PURCHASE_INVOICE",
  INTERNAL_PURCHASE_RETURN = "INTERNAL_PURCHASE_RETURN",
  INTERNAL_SUPPLIER_RMA = "INTERNAL_SUPPLIER_RMA",
  INTERNAL_CUSTOMER_RMA = "INTERNAL_CUSTOMER_RMA",
  INTERNAL_PURCHASE_CREDIT_NOTE = "INTERNAL_PURCHASE_CREDIT_NOTE",
  INTERNAL_PURCHASE_DEBIT_NOTE = "INTERNAL_PURCHASE_DEBIT_NOTE",
  INTERNAL_SALES_INVOICE = "INTERNAL_SALES_INVOICE",
  INTERNAL_SALES_RETURN = "INTERNAL_SALES_RETURN",
  INTERNAL_SALES_CREDIT_NOTE = "INTERNAL_SALES_CREDIT_NOTE",
  INTERNAL_SALES_DEBIT_NOTE = "INTERNAL_SALES_DEBIT_NOTE",

  // Documents for Employees (affects GL)
  INTERNAL_SALARY_ADVICE = "INTERNAL_SALARY_ADVICE",
  INTERNAL_SALARY_PAYMENT_VOUCHER = "INTERNAL_SALARY_PAYMENT_VOUCHER",

  // Documents for Inventory Control (affects GL too)
  INTERNAL_PURCHASE_GOODS_RECEIVED_NOTE = "INTERNAL_PURCHASE_GOODS_RECEIVED_NOTE",
  INTERNAL_PURCHASE_GOODS_ISSUED_NOTE = "INTERNAL_PURCHASE_GOODS_ISSUED_NOTE",
  INTERNAL_SALES_GOODS_RECEIVED_NOTE = "INTERNAL_SALES_GOODS_RECEIVED_NOTE",
  INTERNAL_SALES_GOODS_ISSUED_NOTE = "INTERNAL_SALES_GOODS_ISSUED_NOTE",
  INTERNAL_SALES_CONSIGNMENT = "INTERNAL_SALES_CONSIGNMENT",
  INTERNAL_PURCHASE_CONSIGNMENT = "INTERNAL_PURCHASE_CONSIGNMENT",
  INTERNAL_OUTBOUND_STOCK_TRANSFER = "INTERNAL_OUTBOUND_STOCK_TRANSFER",
  INTERNAL_INBOUND_STOCK_TRANSFER = "INTERNAL_INBOUND_STOCK_TRANSFER",
  INTERNAL_STOCK_ADJUSTMENT = "INTERNAL_STOCK_ADJUSTMENT",

  // Document Line for Cash / Payment / Credit Card / Vouchers
  INTERNAL_PAYMENT_VOUCHER = "INTERNAL_PAYMENT_VOUCHER",
  INTERNAL_RECEIPT_VOUCHER = "INTERNAL_RECEIPT_VOUCHER",
  INTERNAL_CLAIM_FORM = "INTERNAL_CLAIM_FORM",

  // Documents that do not have any impact on financial or stocks
  INTERNAL_PURCHASE_REQUISITION = "INTERNAL_PURCHASE_REQUISITION",
  INTERNAL_PURCHASE_QUOTATION = "INTERNAL_PURCHASE_QUOTATION",
  INTERNAL_PURCHASE_ORDER = "INTERNAL_PURCHASE_ORDER",
  INTERNAL_SALES_QUOTATION = "INTERNAL_SALES_QUOTATION",
  INTERNAL_SALES_NEG_QUOTE = "INTERNAL_SALES_NEG_QUOTE",
  INTERNAL_SALES_ORDER = "INTERNAL_SALES_ORDER",
  INTERNAL_JOB_ORDER = "INTERNAL_JOB_ORDER",
  // INTERNAL_CUSTOM	= "PAKITN", TODO:"//"y
  // INTERNAL_CUSTOM	= "SVCCLM", TODO:"//"y
  // INTERNAL_CUSTOM	= "MSESDODR", TODO:"//"y
  INTERNAL_PICKING_PACKING = "INTERNAL_PICKING_PACKING",
  // PACKNT TODO:
  INTERNAL_STOCK_ALLOCATION = "INTERNAL_STOCK_ALLOCATION",
  INTERNAL_STOCK_REQUISITION = "INTERNAL_STOCK_REQUISITION",
  INTERNAL_STOCK_TRANSFER_NOTE = "INTERNAL_STOCK_TRANSFER_NOTE",
  INTERNAL_SALES_RMA = "INTERNAL_SALES_RMA",
  INTERNAL_PURCHASE_RMA = "INTERNAL_PURCHASE_RMA",
  INTERNAL_OUTBOUND_DELIVERY_ORDER = "INTERNAL_OUTBOUND_DELIVERY_ORDER",
  INTERNAL_INBOUND_DELIVERY_ORDER = "INTERNAL_INBOUND_DELIVERY_ORDER",
  INTERNAL_GOODS_DISPATCH_NOTE = "INTERNAL_GOODS_DISPATCH_NOTE",
  INTERNAL_GOODS_DELIVERY_NOTE = "INTERNAL_GOODS_DELIVERY_NOTE",
  INTERNAL_SHOPPING_CART = "INTERNAL_SHOPPING_CART",
  INTERNAL_ABANDONED_CART = "INTERNAL_ABANDONED_CART",
  INTERNAL_PRODUCTION_ORDER = "INTERNAL_PRODUCTION_ORDER",
  INTERNAL_PLANNED_ORDER = "INTERNAL_PLANNED_ORDER",
  INTERNAL_PURCHASE_CONTRACT = "INTERNAL_PURCHASE_CONTRACT",
  INTERNAL_SALES_CONTRACT = "INTERNAL_SALES_CONTRACT",
  INTERNAL_SALES_PROFORMA_INVOICE = "INTERNAL_SALES_PROFORMA_INVOICE",
  INTERNAL_JOBSHEET = "INTERNAL_JOBSHEET",

  // Health Record for Celmonze Consultation Card
  // CUSTOM_DOCUMENT	= "CUSHRC", TODO:"//"y
  INTERNAL_CONSIGNEE_CONSIGNMENT = "INTERNAL_CONSIGNEE_CONSIGNMENT",
  INTERNAL_CONSIGNOR_CONSIGNMENT = "INTERNAL_CONSIGNOR_CONSIGNMENT",
  INTERNAL_SALES_CASHBILL = "INTERNAL_SALES_CASHBILL",
  RTV = "RTV",
  RMA = "RMA",
  INTERNAL_PURCHASE_CONSIGNMENT_GRN = 'INTERNAL_PURCHASE_CONSIGNMENT_GRN',
  INTERNAL_PURCHASE_CONSIGNMENT_GIN = 'INTERNAL_PURCHASE_CONSIGNMENT_GIN',
  INTERNAL_PURCHASE_CONSIGNMENT_INVOICE = 'INTERNAL_PURCHASE_CONSIGNMENT_INVOICE',
  INTERNAL_PURCHASE_CONSIGNMENT_RETURN = 'INTERNAL_PURCHASE_CONSIGNMENT_RETURN',
  INTERNAL_PURCHASE_GRN_STOCK_IN = 'INTERNAL_PURCHASE_GRN_STOCK_IN',
  INTERNAL_SALES_REFUND_NOTE = 'INTERNAL_SALES_REFUND_NOTE',
  INTERNAL_PURCHASE_REFUND_NOTE = 'INTERNAL_PURCHASE_REFUND_NOTE',
  INTERNAL_PURCHASE_SELF_BILLED_INVOICE = 'INTERNAL_PURCHASE_SELF_BILLED_INVOICE',
  INTERNAL_SALES_INVOICE_NO_STOCK_OUT = 'INTERNAL_SALES_INVOICE_NO_STOCK_OUT',
  INTERNAL_PURCHASE_INVOICE_NO_STOCK_IN = 'INTERNAL_PURCHASE_INVOICE_NO_STOCK_IN',
  INTERNAL_CUSTOMER_CONSIGNMENT_OUT = 'INTERNAL_CUSTOMER_CONSIGNMENT_OUT',
  INTERNAL_CUSTOMER_CONSIGNMENT_IN = 'INTERNAL_CUSTOMER_CONSIGNMENT_IN',
  INTERNAL_CASH_TRANSFER = 'INTERNAL_CASH_TRANSFER',
  INTERNAL_CASH_ADJUSTMENT = 'INTERNAL_CASH_ADJUSTMENT'
}

enum DocumentShortCodes {
  // Documents for AR and AP (affects GL)
  INTERNAL_PURCHASE_INVOICE = "PURINV",
  INTERNAL_PURCHASE_RETURN = "PURRTN",
  INTERNAL_SUPPLIER_RMA = "SUPRMA",
  INTERNAL_CUSTOMER_RMA = "CUSRMA",
  INTERNAL_PURCHASE_CREDIT_NOTE = "PURCRN",
  INTERNAL_PURCHASE_DEBIT_NOTE = "PURDBN",
  INTERNAL_SALES_INVOICE = "SLSINV",
  INTERNAL_SALES_RETURN = "SLSRTN",
  INTERNAL_SALES_CREDIT_NOTE = "SLSCRN",
  INTERNAL_SALES_DEBIT_NOTE = "SLSDBN",

  // Documents for Employees (affects GL)
  INTERNAL_SALARY_ADVICE = "SALADV",
  INTERNAL_SALARY_PAYMENT_VOUCHER = "SALVCR",

  // Documents for Inventory Control (affects GL too)
  INTERNAL_PURCHASE_GOODS_RECEIVED_NOTE = "PURGRN",
  INTERNAL_PURCHASE_GOODS_ISSUED_NOTE = "PURGIN",
  INTERNAL_SALES_GOODS_RECEIVED_NOTE = "SLSGRN",
  INTERNAL_SALES_GOODS_ISSUED_NOTE = "SLSGIN",
  INTERNAL_SALES_CONSIGNMENT = "SLSCSM",
  INTERNAL_PURCHASE_CONSIGNMENT = "PURCSM",
  INTERNAL_OUTBOUND_STOCK_TRANSFER = "OBDSTF",
  INTERNAL_INBOUND_STOCK_TRANSFER = "IBNSTF",
  INTERNAL_STOCK_ADJUSTMENT = "STOADJ",

  // Document Line for Cash / Payment / Credit Card / Vouchers
  INTERNAL_PAYMENT_VOUCHER = "PAYVCR",
  INTERNAL_RECEIPT_VOUCHER = "RCTVCR",
  INTERNAL_CLAIM_FORM = "CLMFRM",

  // Documents that do not have any impact on financial or stocks
  INTERNAL_PURCHASE_REQUISITION = "PURREQ",
  INTERNAL_PURCHASE_QUOTATION = "PURQUO",
  INTERNAL_PURCHASE_ORDER = "PURODR",
  INTERNAL_SALES_QUOTATION = "SLSQUO",
  INTERNAL_SALES_NEG_QUOTE = "SLSNQU",
  INTERNAL_SALES_ORDER = "SLSODR",
  INTERNAL_JOB_ORDER = "JOBODR",
  // INTERNAL_CUSTOM	= "PAKITN", TODO: Verify
  // INTERNAL_CUSTOM	= "SVCCLM", TODO: Verify
  // INTERNAL_CUSTOM	= "MSESDODR", TODO: Verify
  INTERNAL_PICKING_PACKING = "PICKNT",
  // PACKNT TODO:
  INTERNAL_STOCK_ALLOCATION = "STKALL",
  INTERNAL_STOCK_REQUISITION = "STKREQ",
  INTERNAL_STOCK_TRANSFER_NOTE = "STKTRF",
  INTERNAL_SALES_RMA = "SLSRMA",
  INTERNAL_PURCHASE_RMA = "PURRMA",
  INTERNAL_OUTBOUND_DELIVERY_ORDER = "OBDODR",
  INTERNAL_INBOUND_DELIVERY_ORDER = "IBDODR",
  INTERNAL_GOODS_DISPATCH_NOTE = "GDSPNT",
  INTERNAL_GOODS_DELIVERY_NOTE = "GDLYNT",
  INTERNAL_SHOPPING_CART = "SHPCRT",
  INTERNAL_ABANDONED_CART = "ABDCRT",
  INTERNAL_PRODUCTION_ORDER = "PRDODR",
  INTERNAL_PLANNED_ORDER = "PLNODR",
  INTERNAL_PURCHASE_CONTRACT = "PURCNT",
  INTERNAL_SALES_CONTRACT = "SLSCNT",
  INTERNAL_SALES_PROFORMA_INVOICE = "SLPINV",
  INTERNAL_JOBSHEET = "JOBSHT",

  // Health Record for Celmonze Consultation Card
  // CUSTOM_DOCUMENT	= "CUSHRC", TODO: Verify
  INTERNAL_CONSIGNEE_CONSIGNMENT = "CSECON",
  INTERNAL_CONSIGNOR_CONSIGNMENT = "CSRCON",
  INTERNAL_SALES_CASHBILL = "SLSCSH",
  RTV = "SUPRTV",
  RMA = "CUSRMA",
  INTERNAL_PURCHASE_CONSIGNMENT_GRN = 'CSGGRN',
  INTERNAL_PURCHASE_CONSIGNMENT_GIN = 'CSGGIN',
  INTERNAL_PURCHASE_CONSIGNMENT_INVOICE = 'CSGINV',
  INTERNAL_PURCHASE_CONSIGNMENT_RETURN = 'CSGRTN',
  INTERNAL_PURCHASE_GRN_STOCK_IN = 'PURGRNSI',
  INTERNAL_SALES_REFUND_NOTE = 'ISRN',
  INTERNAL_PURCHASE_REFUND_NOTE = 'IPRN',
  INTERNAL_PURCHASE_SELF_BILLED_INVOICE = 'IPSBI',
  INTERNAL_SALES_INVOICE_NO_STOCK_OUT = 'SLSINVNSO',
  INTERNAL_PURCHASE_INVOICE_NO_STOCK_IN = 'PURINVNSI',
  INTERNAL_CUSTOMER_CONSIGNMENT_OUT = 'CCSOUT',
  INTERNAL_CUSTOMER_CONSIGNMENT_IN = 'CCSINN',
  INTERNAL_CASH_TRANSFER = 'CSHTFR',
  INTERNAL_CASH_ADJUSTMENT = 'CSHADJ'
}

const DocumentShortCodesMap = new Map<string, string>([
  ['INTERNAL_PURCHASE_INVOICE', 'PURINV'],
  ['INTERNAL_PURCHASE_RETURN', 'PURRTN'],
  ['INTERNAL_SUPPLIER_RMA', 'SUPRMA'],
  ['INTERNAL_CUSTOMER_RMA', 'CUSRMA'],
  ['INTERNAL_PURCHASE_CREDIT_NOTE', 'PURCRN'],
  ['INTERNAL_PURCHASE_DEBIT_NOTE', 'PURDBN'],
  ['INTERNAL_SALES_INVOICE', 'SLSINV'],
  ['INTERNAL_SALES_RETURN', 'SLSRTN'],
  ['INTERNAL_SALES_CREDIT_NOTE', 'SLSCRN'],
  ['INTERNAL_SALES_DEBIT_NOTE', 'SLSDBN'],
  ['INTERNAL_SALARY_ADVICE', 'SALADV'],
  ['INTERNAL_SALARY_PAYMENT_VOUCHER', 'SALVCR'],
  ['INTERNAL_PURCHASE_GOODS_RECEIVED_NOTE', 'PURGRN'],
  ['INTERNAL_PURCHASE_GOODS_ISSUED_NOTE', 'PURGIN'],
  ['INTERNAL_SALES_GOODS_RECEIVED_NOTE', 'SLSGRN'],
  ['INTERNAL_SALES_GOODS_ISSUED_NOTE', 'SLSGIN'],
  ['INTERNAL_SALES_CONSIGNMENT', 'SLSCSM'],
  ['INTERNAL_PURCHASE_CONSIGNMENT', 'PURCSM'],
  ['INTERNAL_OUTBOUND_STOCK_TRANSFER', 'OBDSTF'],
  ['INTERNAL_INBOUND_STOCK_TRANSFER', 'IBNSTF'],
  ['INTERNAL_STOCK_ADJUSTMENT', 'STOADJ'],
  ['INTERNAL_PAYMENT_VOUCHER', 'PAYVCR'],
  ['INTERNAL_RECEIPT_VOUCHER', 'RCTVCR'],
  ['INTERNAL_CLAIM_FORM', 'CLMFRM'],
  ['INTERNAL_PURCHASE_REQUISITION', 'PURREQ'],
  ['INTERNAL_PURCHASE_QUOTATION', 'PURQUO'],
  ['INTERNAL_PURCHASE_ORDER', 'PURODR'],
  ['INTERNAL_SALES_QUOTATION', 'SLSQUO'],
  ['INTERNAL_SALES_NEG_QUOTE', 'SLSNQU'],
  ['INTERNAL_SALES_ORDER', 'SLSODR'],
  ['INTERNAL_JOB_ORDER', 'JOBODR'],
  // ['INTERNAL_CUSTOM', 'PAKITN'], // TODO: Verify
  // ['INTERNAL_CUSTOM', 'SVCCLM'], // TODO: Verify
  // ['INTERNAL_CUSTOM', 'MSESDODR'], // TODO: Verify
  ['INTERNAL_PICKING_PACKING', 'PICKNT'],
  ['INTERNAL_STOCK_ALLOCATION', 'STKALL'],
  ['INTERNAL_STOCK_REQUISITION', 'STKREQ'],
  ['INTERNAL_STOCK_TRANSFER_NOTE', 'STKTRF'],
  ['INTERNAL_SALES_RMA', 'SLSRMA'],
  ['INTERNAL_PURCHASE_RMA', 'PURRMA'],
  ['INTERNAL_OUTBOUND_DELIVERY_ORDER', 'OBDODR'],
  ['INTERNAL_INBOUND_DELIVERY_ORDER', 'IBDODR'],
  ['INTERNAL_GOODS_DISPATCH_NOTE', 'GDSPNT'],
  ['INTERNAL_GOODS_DELIVERY_NOTE', 'GDLYNT'],
  ['INTERNAL_SHOPPING_CART', 'SHPCRT'],
  ['INTERNAL_ABANDONED_CART', 'ABDCRT'],
  ['INTERNAL_PRODUCTION_ORDER', 'PRDODR'],
  ['INTERNAL_PLANNED_ORDER', 'PLNODR'],
  ['INTERNAL_PURCHASE_CONTRACT', 'PURCNT'],
  ['INTERNAL_SALES_CONTRACT', 'SLSCNT'],
  ['INTERNAL_SALES_PROFORMA_INVOICE', 'SLPINV'],
  ['INTERNAL_JOBSHEET', 'JOBSHT'],
  ['CUSTOM_DOCUMENT', 'CUSHRC'],
  ['INTERNAL_CONSIGNEE_CONSIGNMENT', 'CSECON'],
  ['INTERNAL_CONSIGNOR_CONSIGNMENT', 'CSRCON'],
  ['INTERNAL_SALES_CASHBILL', 'SLSCSH'],
  ['RTV', 'SUPRTV'],
  ['RMA', 'CUSRMA'],
  ['INTERNAL_PURCHASE_CONSIGNMENT_GRN','CSGGRN'],
  ['INTERNAL_PURCHASE_CONSIGNMENT_GIN' ,'CSGGIN'],
  ['INTERNAL_PURCHASE_CONSIGNMENT_INVOICE','CSGINV'],
  ['INTERNAL_PURCHASE_CONSIGNMENT_RETURN','CSGRTN'],
  ['INTERNAL_PURCHASE_GRN_STOCK_IN','PURGRNSI'],
  ['INTERNAL_SALES_REFUND_NOTE','ISRN'],
  ['INTERNAL_PURCHASE_REFUND_NOTE','IPRN'],
  ['INTERNAL_PURCHASE_SELF_BILLED_INVOICE','IPSBI'],
  ['INTERNAL_SALES_INVOICE_NO_STOCK_OUT' ,'SLSINVNSO'],
  ['INTERNAL_PURCHASE_INVOICE_NO_STOCK_IN' , 'PURINVNSI'],
  ['INTERNAL_CUSTOMER_CONSIGNMENT_OUT' , 'CCSOUT'],
  ['INTERNAL_CUSTOMER_CONSIGNMENT_IN' , 'CCSINN'],
  ['INTERNAL_CASH_TRANSFER' , 'CSHTFR'],
  ['INTERNAL_CASH_ADJUSTMENT' , 'CSHADJ'],
]);

export class DocumentShortCodesClass {
  public static readonly ServerDocTypesEnum = ServerDocTypes;
  public static readonly DocumentShortCodesEnum = DocumentShortCodes;
  private static readonly DocumentDocTypeShortCodesMap = DocumentShortCodesMap;

  constructor() { }

  public static getDocTypeShortCodesMap(): ReadonlyMap<string, string> {
    return DocumentShortCodesClass.DocumentDocTypeShortCodesMap;
  }

  public static serverDocTypeToShortCodeMapper(docType: string) {
    if (DocumentShortCodesClass.DocumentDocTypeShortCodesMap.has(docType)) {
      return DocumentShortCodesClass.DocumentDocTypeShortCodesMap.get(docType);
    } else {
      return null;
    }
  }

  public static prefix(sDocType: string, runningNumber: string) {
    const shortCode = DocumentShortCodesClass.serverDocTypeToShortCodeMapper(sDocType);
    return `${shortCode ? shortCode : ''}${runningNumber}`;
  }
}
